export const option = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: { enabled: false },
  hover: { mode: null },
  legend: {
    display: false,
  },
  scale: {
    ticks: {
      beginAtZero: true,
      maxTicksLimit: 10,
      showLabelBackdrop: false,
      fontColor: "#000000",
      fontSize: 14,
      display: false,
    },
    pointLabels: {
      fontColor: "#000000",
      fontSize: 14,
    },
    gridLines: {
      color: "rgba(0, 0, 0, 0.3)",
    },
    angleLines: {
      color: "rgba(0, 0, 0, 0.3)",
    },
  },
};